// src/Compensation.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Compensation_default = createIcon({
  displayName: "Compensation",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { opacity: "0", width: "24", height: "24", fill: "white", fillOpacity: "0" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M18.3657 5.89934C18.174 5.78691 18.0098 5.63321 17.8849 5.44939L11.9272 7.00015H3.99015L19.2279 3.03233C19.355 2.9992 19.4874 2.99144 19.6175 3.00949C19.7476 3.02754 19.8729 3.07105 19.9862 3.13754C20.0995 3.20402 20.1986 3.29218 20.2778 3.39697C20.357 3.50176 20.4148 3.62113 20.4479 3.74826L21.2949 7.00015H19.2279L18.9931 6.0994C18.7717 6.08011 18.5574 6.01178 18.3657 5.89934ZM21 9.00006H3C2.73478 9.00006 2.48043 9.10542 2.29289 9.29295C2.10536 9.48049 2 9.73484 2 10.0001V20.0001C2 20.2653 2.10536 20.5196 2.29289 20.7072C2.48043 20.8947 2.73478 21.0001 3 21.0001H21C21.2652 21.0001 21.5196 20.8947 21.7071 20.7072C21.8946 20.5196 22 20.2653 22 20.0001V10.0001C22 9.73484 21.8946 9.48049 21.7071 9.29295C21.5196 9.10542 21.2652 9.00006 21 9.00006ZM20 18.0871C19.7896 18.1619 19.5985 18.2826 19.4406 18.4405C19.2827 18.5985 19.1621 18.7896 19.0874 19.0001H4.91259C4.83801 18.7896 4.71738 18.5984 4.5595 18.4404C4.40162 18.2825 4.21047 18.1618 4 18.0871V11.913C4.21047 11.8384 4.40162 11.7176 4.5595 11.5597C4.71738 11.4018 4.83801 11.2106 4.91259 11.0001H19.0874C19.1622 11.2105 19.2829 11.4016 19.4409 11.5594C19.5988 11.7173 19.7899 11.838 20.0004 11.9127L20 18.0871ZM12 18.0009C13.6569 18.0009 15 16.6577 15 15.0009C15 13.344 13.6569 12.0009 12 12.0009C10.3432 12.0009 9.00002 13.344 9.00002 15.0009C9.00002 16.6577 10.3432 18.0009 12 18.0009Z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
      }
    )
  ] })
});

export {
  Compensation_default
};
